"use strict";

exports.__esModule = true;
var _TimelineSubscription = require("./TimelineSubscription");
Object.keys(_TimelineSubscription).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TimelineSubscription[key]) return;
  exports[key] = _TimelineSubscription[key];
});
var _AdvancedTimelineSubscription = require("./AdvancedTimelineSubscription");
Object.keys(_AdvancedTimelineSubscription).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AdvancedTimelineSubscription[key]) return;
  exports[key] = _AdvancedTimelineSubscription[key];
});